import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Pencil, Trash2, MoreHorizontal } from 'lucide-vue-next'
  import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger
  } from '@/components/ui/dropdown-menu'
  import { Button } from '@/components/ui/button'
  import {ref, watch} from "vue";
  import DeleteDialog from "@/components/tables/DeleteDialog.vue";
  import useEventsBus from "@/utils/eventBus";
  import MastersEditForm from "@/components/tables/masters/MastersEditForm.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MastersDataTableDropDown',
  props: {
    object: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props

  const isDeleteDialogOpen = ref(false);
  const isEditDialogOpen = ref(false);
  const { bus } = useEventsBus();

  const setIsEditDialogOpen = (value: boolean) => {
    isEditDialogOpen.value = value;
  };

  const setIsDeleteDialogOpen = (value: boolean) => {
    isDeleteDialogOpen.value = value;
  };

  watch(() => bus.value.get('update_'+props.entity), async () => {
    setIsDeleteDialogOpen(false);
    setIsEditDialogOpen(false);
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            class: "w-8 h-8 p-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MoreHorizontal), { class: "w-4 h-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenuLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setIsEditDialogOpen(true)), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Pencil), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.edit')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsDeleteDialogOpen(true)), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(MastersEditForm, {
        entity: props.entity,
        object: props.object,
        open: isEditDialogOpen.value,
        "set-open": setIsEditDialogOpen
      }, null, 8, ["entity", "object", "open"]),
      _createVNode(DeleteDialog, {
        entity: props.entity,
        object: props.object,
        open: isDeleteDialogOpen.value,
        "set-open": setIsDeleteDialogOpen
      }, null, 8, ["entity", "object", "open"])
    ]),
    _: 1
  }))
}
}

})